import { Stack } from '@mui/material';
import { FiscalData } from './FiscalData/FiscalData';
import { PaymentData } from './PaymentData/PaymentData';

export function PaymentAndFiscalData() {
  return (
    <Stack spacing={'50px'} mt={{ xs: '20px', md: '40px' }}>
      <FiscalData />
      <PaymentData />
    </Stack>
  );
}
